(() => {
  if (window.__nnMobileChapterThresholdsLoaded) return;
  window.__nnMobileChapterThresholdsLoaded = true;

  const chapters = [
    ['section[id$="__hero_6atm6w"]', '01', 'Your Compass'],
    ['section[id$="__hero_8mzDbi"]', '02', 'Your Places'],
    ['.nn-editorial-collage--chapter-three', '03', 'Your Story'],
  ];

  const mount = () => {
    if (window.location.pathname !== '/') return;

    chapters.forEach(([selector, number, title]) => {
      const section = document.querySelector(selector);
      if (!section || document.querySelector(`[data-nn-chapter-threshold="${number}"]`)) return;

      const threshold = document.createElement('header');
      threshold.className = 'nn-mobile-chapter-threshold';
      threshold.dataset.nnChapterThreshold = number;
      threshold.setAttribute('aria-label', `Chapter ${number}: ${title}`);
      threshold.innerHTML = `
        <p class="nn-mobile-chapter-threshold__number">Chapter ${number}</p>
        <p class="nn-mobile-chapter-threshold__title">${title}</p>
      `;
      section.parentNode?.insertBefore(threshold, section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);
  window.setTimeout(mount, 700);
})();
